<mat-toolbar color="primary" class="toolbar">
    <button [id]="'button_back-button_NavegarBack'" mat-icon-button (click)="logout()" color="secondary">
        <mat-icon aria-label="label">navigate_before</mat-icon>
    </button>
</mat-toolbar>

<mat-card>
    <ngx-spinner [fullScreen]="false" bdColor="rgba(0,0,0,0.2)" type="ball-spin" size="default"> </ngx-spinner>
    <mat-card-header fxLayout="column">
        <mat-card-title fxFlex fxLayoutAlign="center center">
            <b> {{ "CHANGE_PASSWORD.TITLE" | translate }} </b>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="form-container" fxLayout="column">
            <mat-form-field fxFlex>
                <mat-label>{{ "CHANGE_PASSWORD.OLD_PASSWORD" | translate }}</mat-label>
                <input
                    [id]="'input_profile-change-password_Password'"
                    matInput
                    required
                    type="password"
                    #oldPasswordInput
                    [(ngModel)]="oldPassword"
                />
                <mat-icon
                    matSuffix
                    color="secondary"
                    (click)="oldPasswordInput.type = oldPasswordInput.type == 'text' ? 'password' : 'text'"
                >
                    {{ oldPasswordInput.type == "text" ? "visibility_off" : "visibility" }}
                </mat-icon>
            </mat-form-field>

            <app-password-validator
                [passwordRegex]="getPasswordRegex()"
                [passwordCustomRules]="getPasswordCustomRules()"
                (validValue)="validPassword = $event"
                (password)="newPassword = $event"
            ></app-password-validator>
        </div>
    </mat-card-content>
    <mat-card-actions align="end">
        <button mat-raised-button (click)="logout()" color="warn">
            {{ "CHANGE_PASSWORD.CANCEL" | translate }}
        </button>
        <button
            mat-raised-button
            (click)="save()"
            [disabled]="!validPassword || oldPassword.length == 0"
            color="primary"
        >
            {{ "CHANGE_PASSWORD.SAVE" | translate }}
        </button>
    </mat-card-actions>
</mat-card>
